import React, {Component} from 'react';
import {connect} from 'react-redux';
import Person from './person';
import * as actions from '../../actions';
import {toJS} from "../hocs/toJs";

const parseRoles = (roles) => {
  const parsedRoles = [];
  roles.valueSeq().toArray().forEach(role => {
    parsedRoles.push({
      id: role.get('id'),
      name: role.get('name'),
    })
  });
  return parsedRoles;
};

const parseDepartments = (department) => {
  const parsedDepartments = [];
  department.valueSeq().toArray().forEach( department => (
    parsedDepartments.push({
      id: department.get('id'),
      name: department.get('name'),
      weightOld: department.get('weightOld'),
      weightNew: department.get('weightNew'),
      weightNewComing: department.get('weightNewComing'),
      createdDate: department.get('createdDate'),
    })));
  return parsedDepartments;
};

const parsePerson = (person) => {
  let personRoles = [];
  if(person.get('roles')){
    personRoles = parseRoles(person.get('roles'));
  }
  return {
    id: person.get('id'),
    username: person.get('username'),
    email: person.get('email'),
    password: person.get('password'),
    roleId: personRoles.length > 0? personRoles[0].id:'',
    departmentId: person.get('departmentId'),
  }
};

class PersonHOC extends Component {

  componentDidMount(){
    this.props.getRoles();
    this.props.getDepartments({filter: {where: {or: [{deleted: false}, {deleted: null}]}}});

    if(this.props.match.params.id){
      this.props.getPersonById({id:this.props.match.params.id})
    }

  }

  parseForm = (formIM) => {
    return {
      username: formIM.get('username'),
      email: formIM.get('email'),
      password: formIM.get('password'),
      roleId: formIM.get('roleId'),
      departmentId: formIM.get('departmentId'),
    }
  };

  parsePasswordForm = (formIM) => {
    return {
      newPassword: formIM.get('newPassword'),
      retypedNewPassword: formIM.get('retypedNewPassword')
    }
  };

  submitPerson = (formIM) => {
    const form = this.parseForm(formIM);
    if(this.props.match.params.id){
      this.props.updatePerson({
        id:this.props.match.params.id,
        sendBody: form
      })
    } else {
      this.props.createPerson({sendBody: form});
    }
  };

  submitPassword = (formIM) => {
    const form = this.parsePasswordForm(formIM);
    if(form.newPassword !== form.retypedNewPassword){
      this.props.changePersonState({key: 'resetPasswordMessage', value: 'Passwords does not match'});
      return;
    }
    this.props.resetPassword({sendBody: {newPassword: form.newPassword}, id: this.props.match.params.id})
  };

  render(){
    return (
      <Person
        {...this.props}
        submitPerson={this.submitPerson}
        submitPassword={this.submitPassword}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    roles: state.roles.get('roles'),
    departments: state.departments.get('departments'),
    person: state.person.get('person'),
    loading: state.person.get('fetching') || state.person.get('posting') || state.person.get('patching'),
    message: state.person.get('message'),
    isPasswordModalOpen: state.person.get('isPasswordModalOpen'),
    resetPasswordMessage: state.person.get('resetPasswordMessage'),
    resettingPassword: state.person.get('resettingPassword'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    createPerson: (payload) => {
      dispatch(actions.createPerson(payload))
    },
    getRoles: (payload) => {
      dispatch(actions.getRoles(payload))
    },
    getDepartments: (payload) => {
      dispatch(actions.getDepartments(payload))
    },
    getPersonById: (payload) => {
      dispatch(actions.getPersonById(payload))
    },
    updatePerson: (payload) => {
      dispatch(actions.updatePerson(payload))
    },
    changePersonState: (payload) => {
      dispatch(actions.changePersonState(payload))
    },
    resetPassword: (payload) => {
      dispatch(actions.resetPassword(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PersonHOC));



// WEBPACK FOOTER //
// ./src/components/person/personHOC.js